import client from '../graphql-client';
import gql from 'graphql-tag';

export const CURRENT_USER_QUERY = gql`
  query currentUserQuery {
    currentUser {
      id
      email
      name
    }
  }
`;

export default {
  isAuthenticated: () => {
    try {
      return (
        Boolean(localStorage.getItem('token')) &&
        Boolean(localStorage.getItem('refreshToken'))
      );
    } catch (e) {
      return false;
    }
  },
  logout: cb => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
    } catch (e) {}

    setTimeout(cb, 100);
  },
  getCurrentUser: () => {
    try {
      const { currentUser } = client.readQuery({
        query: CURRENT_USER_QUERY,
      });

      return currentUser;
    } catch (e) {
      return null;
    }
  },
  getTokens: () => ({
    token: localStorage.getItem('token') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
  }),
};
